export default {
  title: '通知',
  centerTitle: '待處理事項',
  pendingCount: '待處理通知',
  normalNotice: '普通',
  importantNotice: '重要',
  criticalNotice: '緊急',
  noticeTypeAnnouncement: '公告',
  noticeTypeDataOverwrite: '數據覆蓋',
  noticeTypeUpgrade: '系統升級',
  noticeTypeVote: '投票',
  noticeTypeSurvey: '問卷',
  noticeTypeResearch: '調研',
  ack: '我已知悉',
  applyDelay: '申請延期',
  selectDelayTime: '請選擇延期時間',
  feedback: '反饋',
  feedbackPlaceholder: '請輸入反饋內容',
  feedbackRequired: '請輸入反饋內容',
  survey: '問卷調查',
  answerPlaceholder: '請輸入答案',
  answerRequired: '請完成必填題目',
  openLink: '查看詳情',
  submitSuccess: '提交成功',
  forceShowCloseBlocked: '當前通知為強制顯示，請按通知要求處理後再關閉。'
};
